import { gql } from '@efficiently/client-core-graphql-models';

/**
 * No variables: the project is read server-side from the caller's app context.
 *
 * A caller without `DesignChangeView` gets `[]` rather than an error, so this operation has no
 * failure branch to model on the client beyond an ordinary transport failure.
 */
export const DESIGN_CHANGE_PENDING_PROJECT_FINISH_IDS = gql(`
	query DesignChangePendingProjectFinishIds {
		designChangePendingProjectFinishIds
	}
`);
